import history from 'login-utils/history';

import * as actionTypes from 'login-actions/actionTypes';
import * as mobileUtils from 'login-utils/mobileUtils';

export default (
  state: RouterState = {
    isOutdatedBrowser: window.IS_OUTDATED_BROWSER || false,
    viewType: mobileUtils.getViewType(),
    lastRoute: history.getCurrentLocation().pathname,
    lastAttemptedRoute: null,
  },
  action: FluxStandardAction<any, any>,
) => {
  switch (action.type) {
    case actionTypes.UPDATE_OUTDATED_STATE:
      return { ...state, isOutdatedBrowser: action.payload };
    case actionTypes.UPDATE_VIEW_TYPE:
      return { ...state, viewType: action.payload };
    case actionTypes.UPDATE_LAST_ROUTE:
      return { ...state, lastRoute: action.payload };
    case actionTypes.UPDATE_LAST_ATTEMPTED_ROUTE:
      return { ...state, lastAttemptedRoute: action.payload };
    case actionTypes.UPDATE_LOAN_TYPE:
      return { ...state, loanType: action.payload };
    default:
      return state;
  }
};
